module.exports = __webpack_public_path__ + "static/media/lf-dark-triange.b225c877.svg";